var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubscribeMap',{attrs:{"items":_vm.wards,"api_url":_vm.$WARDS_API,"column_name":"the_geom"},on:{"choose":_vm.choose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }